import React, { useState, useEffect } from "react";
import EmpresaSelect from "./EmpresaSelect";
import MontoInput from "./MontoInput";
import PlazoSelect from "./PlazoSelect";
import SeguroCheckbox from "./SeguroCheckbox";
import CuotaDisplay from "./CuotaDisplay";
import SeguroDisclaimer from "./SeguroDisclaimer";
import Button from "./Button";
import { usePlazos } from "../hooks/usePlazos"; 
import useTasa from "../hooks/useTasa";
import { calcularCuotaFinal } from "../services/calculoService";
import { useTranslationContext } from "../context/TranslationsProvider";

const SimulatorForm = ({ configuration }) => {
  const [empresa, setEmpresa] = useState("");
  const [monto, setMonto] = useState("");
  const [plazo, setPlazo] = useState("");
  const [seguro, setSeguro] = useState(false);
  const [cuota, setCuota] = useState(null);
  const [valorSeguro, setValorSeguro] = useState(null);
  const [tasaEA, setTasaEA] = useState(null);
  const [showResults, setShowResults] = useState(false);

  const { translations } = useTranslationContext();
  const t = (key, fallback) => translations[key] || fallback;

  const {
    plazos,
    mensaje: mensajePlazo,
    esValido: montoValido,
    limites
  } = usePlazos(monto, configuration);

  const { tasa } = useTasa({ empresa, plazo, configuration });

  const formIsValid = empresa && monto && plazo && montoValido;

  useEffect(() => {
    setMonto("");
    setPlazo("");
    setSeguro(false);
    setCuota(null);
    setValorSeguro(null);
    setTasaEA(null);
    setShowResults(false);
  }, [empresa]);

  useEffect(() => {
    if (showResults && formIsValid && monto && plazo && tasa) {
      try {
        const { cuota: c, valorSeguro: vs, tasaEA: ea } = calcularCuotaFinal({
          monto,
          plazo,
          tasa: tasa.tasa,
          diasLibranza: tasa.diasLibranza.key,
          tipoConvenio: tasa.tipoConvenio,
          seguro
        });
        setCuota(c);
        setValorSeguro(vs);
        setTasaEA(ea);
      } catch (error) {
        setCuota(null);
        setValorSeguro(null);
        setTasaEA(null);
      }
    } else {
      setCuota(null);
      setValorSeguro(null);
      setTasaEA(null);
    }
  }, [showResults, formIsValid, monto, plazo, tasa, seguro]);

  const handleEmpresaChange = setEmpresa;
  const handleMontoChange   = v => { setMonto(v);   if (showResults) setShowResults(false); };
  const handlePlazoChange   = v => { setPlazo(v);   if (showResults) setShowResults(false); };
  const handleSeguroChange  = setSeguro;
  const handleSimular       = e => {
    e.preventDefault();
    if (formIsValid) setShowResults(true);
  };

  return (
    <div className="simulator-container">
      <div className={`libranza-simulator ${showResults ? "show-results" : ""}`}>
        <div className="simulator-form-container">
          <form className="simulator-form" onSubmit={handleSimular}>
            <EmpresaSelect
              empresa={empresa}
              setEmpresa={handleEmpresaChange}
              configuration={configuration}
            />

            <MontoInput
              monto={monto}
              setMonto={handleMontoChange}
              mensajePlazo={mensajePlazo}
              limites={limites}
            />

            <PlazoSelect
              plazo={plazo}
              setPlazo={handlePlazoChange}
              plazosDisponibles={plazos}
            />

            <SeguroCheckbox
              seguro={seguro}
              setSeguro={handleSeguroChange}
            />

            <Button disabled={!formIsValid}>
              {t("bdo-libranza-button-simulate", "Simular")}
            </Button>
          </form>
        </div>

        {showResults && formIsValid && cuota != null && (
          <div className="simulator-result-container">
            <CuotaDisplay
              monto={monto}
              plazo={plazo}
              tasaEA={tasaEA}
              tasaMensual={tasa?.tasa}
              cuota={cuota}
              seguro={seguro}
              valorSeguro={valorSeguro}
              solicitudCreditoUrl={configuration.solicitudCreditoUrl}
              solicitudAsesoriaUrl={configuration.solicitudAsesoriaUrl}
            />
          </div>
        )}
      </div>

      {showResults && (
        <div className="disclaimer-container visible">
          <SeguroDisclaimer />
        </div>
      )}
    </div>
  );
};

export default SimulatorForm;
